module.exports = __webpack_public_path__ + "static/media/rolling.8706856e.svg";